import React from 'react'
import { useNavigate } from 'react-router-dom'
import Topbar from '../components/Topbar'
import Sidebar from '../components/Sidebar'
import styles from '../assets/css/Attendence.module.css'
import { FaLaptop, FaRoad, FaUsers, FaCalendarAlt } from 'react-icons/fa'

function Attendence() {
  const navigate = useNavigate()

  const handleViewReport = (section) => {
    navigate(`/attendence/report/${section}`)
  }

  return (
    <>
      <Topbar/>
      <div className='d-flex'>
        <Sidebar/>
        <div className={styles.attendenceContainer}>
          <div className={styles.attendenceContent}>
            <h2 className={styles.pageTitle}>Attendance Management</h2>
            <div className={styles.cardGrid}>
              {/* IT Section Card */}
              <div className={styles.card}>
                <div className={styles.cardHeader}>
                  <div className={styles.iconWrapper}>
                    <FaLaptop className={styles.icon} />
                  </div>
                  <div className={styles.headerContent}>
                    <h3 className={styles.cardTitle}>IT Section</h3>
                    <p className={styles.cardDescription}>
                      Manage IT Section staff attendance and activities
                    </p>
                  </div>
                </div>
                <div className={styles.statsContainer}>
                  <div className={styles.statBox}>
                    <FaUsers className={styles.statIcon} />
                    <div className={styles.statContent}>
                      <div className={styles.statValue}>50</div>
                      <div className={styles.statLabel}>Staff</div>
                    </div>
                  </div>
                  <div className={styles.statBox}>
                    <FaCalendarAlt className={styles.statIcon} />
                    <div className={styles.statContent}>
                      <div className={styles.statValue}>25</div>
                      <div className={styles.statLabel}>Present</div>
                    </div>
                  </div>
                </div>
                <button 
                  className={styles.viewReportBtn}
                  onClick={() => handleViewReport('it')}
                >
                  View Report
                </button>
              </div>

              {/* PWD Section Card */}
              <div className={styles.card}>
                <div className={styles.cardHeader}>
                  <div className={styles.iconWrapper}>
                    <FaRoad className={styles.icon} />
                  </div>
                  <div className={styles.headerContent}>
                    <h3 className={styles.cardTitle}>PWD Section</h3>
                    <p className={styles.cardDescription}>
                      Manage PWD Section staff attendance and activities
                    </p>
                  </div>
                </div>
                <div className={styles.statsContainer}>
                  <div className={styles.statBox}>
                    <FaUsers className={styles.statIcon} />
                    <div className={styles.statContent}>
                      <div className={styles.statValue}>75</div>
                      <div className={styles.statLabel}>Staff</div>
                    </div>
                  </div>
                  <div className={styles.statBox}>
                    <FaCalendarAlt className={styles.statIcon} />
                    <div className={styles.statContent}>
                      <div className={styles.statValue}>40</div>
                      <div className={styles.statLabel}>Present</div>
                    </div>
                  </div>
                </div>
                <button 
                  className={styles.viewReportBtn}
                  onClick={() => handleViewReport('pwd')}
                >
                  View Report
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Attendence 